module.exports = __webpack_public_path__ + "img/stickies.b7f0b43b.svg";